import React, { useMemo } from 'react';
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useAuth } from "../../providers/AuthProvider";

const TalentLayout = props => {

    const { auth, isLoaded } = useAuth();
    const location = useLocation();
    if (isLoaded && (!auth || !(auth.isTalent() || auth.canManageTalent()))) {
        return <Navigate to={TB.auth().appropriate()} state={{ from: location }} replace />;
    }

    // const shouldRedirect = useMemo(() => {
    //     if (isLoaded && location) {
    //         return TB.auth().isAppropriate(location)
    //     }
    //     return true;
    // }, [location?.pathname, auth]);
    //
    //
    // if (shouldRedirect && TB.auth().appropriate() !== location.pathname) {
    //     return <Navigate to={TB.auth().appropriate()} replace={true}/>
    // }


    // if (auth.isBeingReviewed()) {
    //     return navigate('/talent/under-review', {replace: true});
    // }
    // if (!auth.isApplicationApproved()) {
    //     return navigate('/talent/application', {replace: true});
    // }
    // if (TB.auth().shouldSeeTalentWelcome()) {
    //     return navigate('/talent-welcome', {replace: true});
    // }
    // if (TB.auth().shouldSeeTalentAppUpdate()) {
    //     return navigate('/talent-welcome-update', {replace: true});
    // }
    //
    // if (!auth.hasCompletedApplication()) {
    //     return navigate(auth.currentApplicationStep().getPath(), {replace: true});
    // }

    const authName = useMemo(() => auth.firstNamePlusInitial(), [auth.id]);

    const pageTitle = (name) => {
        if (location.pathname.includes('talent/projects')) {
            return 'Projects'
        } else if (location.pathname.includes('talent/job-board')) {
            return 'Job Board'
        } else if (location.pathname.includes('talent/teams')) {
            return 'Teams'
        } else if (location.pathname.includes('talent/work-preferences')) {
            return 'Work Preferences'
        } else if (location.pathname.includes('talent/contracts')) {
            return 'Contracts'
        }
        return name
    }

    return (
        <>
            <Helmet>
                <title>{pageTitle(authName)} | Wripple</title>
            </Helmet>
            <Outlet />
        </>
    );
};

TalentLayout.propTypes = {

};

export default TalentLayout;